import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/_db";
import { FootprintProduct } from "@/types/results";

export const useOriginProduct = (companyId: string | null, productId: string | null) => {
  const [originProduct, setOriginProduct] = useState<FootprintProduct | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOriginProduct = async () => {
      if (!companyId || !productId) {
        setOriginProduct(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const productRef = doc(db, "footprint_products", productId);
        const productSnap = await getDoc(productRef);

        if (productSnap.exists()) {
          const productData = productSnap.data() as FootprintProduct;
          setOriginProduct(productData);
        } else {
          setOriginProduct(null);
          setError("Origin product not found.");
        }
      } catch (err) {
        console.error("Error fetching origin product:", err);
        setError("Failed to fetch origin product data.");
        setOriginProduct(null);
      } finally {
        setLoading(false);
      }
    };

    fetchOriginProduct();
  }, [companyId, productId]);

  return { originProduct, loading, error };
};
